import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalCloseButton,
  ModalHeader,
  ModalOverlay,
  Flex,
  Box,
  useDisclosure,
  useToast,
  Textarea,
  Text,
} from '@chakra-ui/react'
import { Button } from '../../../../components/Button'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { useMutation } from 'react-query'
import { zodResolver } from '@hookform/resolvers/zod'
import { api } from '../../../../services/api'
import { useUser } from '../../../../hooks/useUser'
import { useMemo } from 'react'

async function solicitarLiberacao(data) {
  const res = await api.post('/site/v2/liberacao-pedido/solicita-liberacao-ilustracao', data)

  return res.data
}

const schema = z.object({
  observacao: z.string().nonempty('Observação é obrigatória.'),
  numero_pedido: z.string().nonempty('Número do pedido é obrigatório.'),
  numero_nota: z.string().nonempty('Número da nota é obrigatório.'),
  codigo_vendedor: z.string().nonempty('Código do vendedor é obrigatório.'),
  valor_pedido: z.string().nonempty('Valor do pedido é obrigatório.'),
})

export const SolicitarLiberacaoSemCompreGanhe = ({ ...props }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { register, handleSubmit, control, formState } = useForm({
    resolver: zodResolver(schema),
  })

  const summary = useMemo(() => {
    const summaryItems = props.itens.reduce(
      (acc, item) => {
        const { quantidade, preco_venda } = item
        const total = quantidade * preco_venda

        acc.total += total
        return {
          ...acc,
        }
      },
      { total: 0, frete: 0, totalPedido: 0 }
    )

    return summaryItems
  }, [props.itens])

  const totalPedido = !props.dados_transportadora.frete_gratis
    ? summary.total + parseFloat(props.dados_transportadora.valor_frete_30) + parseFloat(props.dados_pedido.valor_substituicao)
    : summary.total + parseFloat(props.dados_pedido.valor_substituicao)

  console.log(props)

  const { codigo_vendedor } = useUser()

  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: solicitarLiberacao,
    onSuccess: () => {
      toast({
        title: 'Liberação solicitada com sucesso',
        description: 'Aguarde a aprovação do setor responsável.',
        status: 'success',
      })
      onClose()
    },
    onError: (error) => {
      toast({
        title: 'Erro ao solicitar liberação',
        description: error.response.data.erros,
        status: 'error',
      })
    },
  })

  async function onSubmit(data) {
    await mutateAsync({
      ...data,
      observacao_vendedor: data.observacao,
    })
  }

  return (
    <>
      <Button pointerEvents="auto" onClick={onOpen}>
        Solicitar liberação sem Compre e Ganhe
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>Solicitar Liberação sem Compre Ganhe</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex flexDir="column" gap={2} mt={4}>
              <Text as="label" htmlFor="observacao" fontSize="sm">
                Observação
              </Text>
              <Textarea
                id="observacao"
                resize="none"
                rows={4}
                placeholder="Digite a observação"
                name="observacao"
                borderRadius="0"
                bgColor={'#F5F5F5'}
                _hover={{ borderColor: '#F5F5F5' }}
                _focus={{ borderColor: '#F5F5F5' }}
                borderColor={'#F5F5F5'}
                {...register('observacao')}
                error={formState.errors.observacao}
              />
              {formState.errors.observacao && (
                <Box color="red.500" fontSize="sm">
                  {formState.errors.observacao.message}
                </Box>
              )}

              <input type="hidden" {...register('numero_pedido')} value={props.dados_pedido?.numero_pedido} />
              {formState.errors.numero_pedido && (
                <Box color="red.500" fontSize="sm">
                  {formState.errors.numero_pedido.message}
                </Box>
              )}

              <input type="hidden" {...register('numero_nota')} value={props.dados_pedido?.numero_nota} />
              {formState.errors.numero_nota && (
                <Box color="red.500" fontSize="sm">
                  {formState.errors.numero_nota.message}
                </Box>
              )}

              <input type="hidden" {...register('valor_pedido')} value={totalPedido} />
              {formState.errors.valor_pedido && (
                <Box color="red.500" fontSize="sm">
                  {formState.errors.valor_pedido.message}
                </Box>
              )}

              <input type="hidden" {...register('codigo_vendedor')} value={codigo_vendedor} />
              {formState.errors.codigo_vendedor && (
                <Box color="red.500" fontSize="sm">
                  {formState.errors.codigo_vendedor.message}
                </Box>
              )}
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" colorScheme="blue" mr={3} isLoading={isLoading}>
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
